module.exports = __webpack_public_path__ + "static/media/footer-bg.06ee6b01.png";